import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getTask } from '../../services';
import { Urls } from '../../config/urls';

export interface PayoutProcessingFee {
  country: string;
  ratePercentage: number;
  rateFixed: number;
  usdAvailable: boolean;
}

export function usePayoutProcessingFees() {
  const [data, setData] = useState<PayoutProcessingFee[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { auth } = useSelector((state: any) => state);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(false);
      const result = await getTask({
        url: Urls.api.payoutProcessingFees,
        token: auth.token,
      });
      if ('response' in result && result.response) {
        setData(result.response as PayoutProcessingFee[]);
      } else {
        setError(true);
      }
      setLoading(false);
    };

    if (auth.token) {
      fetchData();
    }
  }, [auth.token]);

  return { data, loading, error };
}
